module.exports = __webpack_public_path__ + "static/media/085-no wifi.392255e1.svg";